import { render } from "./칭찬합니다-작성.vue?vue&type=template&id=2a59e1e8"
import script from "./칭찬합니다-작성.vue?vue&type=script&lang=js"
export * from "./칭찬합니다-작성.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__